import * as React from "react";

import { ICandyApiDraftClient } from "../../../../../../Common/CandyApiClient/ICandyApiClient";
import { PRINT_EMBEDDEDLOG_CLICK } from "../../../metricsAction";
import { useMetrics } from "../../../Internals/Metrics/MetricsProviderContext";
import { MenuAction } from "../MenuAction/MenuAction";

export interface PrintErrorLogProps {
    errorLogName: string;
    candyApiDraftClient: ICandyApiDraftClient;
    propsName: string;
}

export function PrintErrorLog(props: PrintErrorLogProps): JSX.Element {
    const track = useMetrics();
    const { errorLogName, propsName } = props;
    const errorLogLink = props.candyApiDraftClient.getHrefToErrorLogPdf(errorLogName, propsName);

    const handleOnClick = () => {
        track(PRINT_EMBEDDEDLOG_CLICK);
    };

    return (
        <MenuAction
            href={errorLogLink}
            data-tid="PrintErrorLog"
            icon="NetDownloadIcon"
            text="Скачать результат проверки"
            onClick={handleOnClick}
        />
    );
}
